import React from "react";
import { useParams } from "react-router-dom";
import { IndustryTemplate } from "../../components/marketing/IndustryTemplate";
import { INDUSTRIES_BY_SLUG } from "../../data/industriesData";
import NotFound from "../NotFound";

export default function IndustryPage() {
  const { slug } = useParams();
  const data = INDUSTRIES_BY_SLUG[slug];
  if (!data) return <NotFound />;
  return <IndustryTemplate data={data} />;
}
